'use client';
import React from 'react';
import { useBuilding } from '../../context/BuildingProvider';
import { cn } from '@/lib/cn';
import { useStore } from '@/providers/StoreProvider';

function BuildingPadding() {
  const { isMasked } = useBuilding();
  const isLoggedIn = useStore(state => state.webAuth.isLoggedIn);
  return (
    <div className={cn('md:hidden bg-secondary-hover', !isLoggedIn || isMasked ? 'h-79' : 'h-4')} />
  );
}

export default BuildingPadding;
